import superagent from 'superagent'
import _ from 'lodash'
import { getCurrentMedia } from '../currentMedia/selectors'
import {
    addError,
    addErrorAlert,
    addSuccessAlert,
} from '../notifications/actions'
import {
    getServerUrl,
} from '../configuration/selectors'
import {
    areCollaborativeIndexationsDisplayed,
    hasCollaborativeIndexations,
    getCollaborativeIndexationSelection,
    isCollaborativeIndexationCreationOpened,
    isCollaborativeIndexationCreationSelectionToolActive,
    getSelectedZone,
    getCollaborativeIndexationCampaignIndexationType,
    isCollaborativeIndexationCreationLocked,
    getCollaborativeIndexationFormFields,
    getCollaborativeIndexationMinimumSelectionSize,
} from './selectors'
import { getScale } from '../canvas/selectors'
import { getCurrentMediaArkName } from '../currentMedia/selectors'
import {
    closeAllLeftAsides,
    lockLeftAside,
    unlockLeftAside,
} from '../aside/actions'
import {
    getCaptcha,
    getCsrfToken,
    isCollaborativeIndexationAutoDisplayEnabled,
    isCollaborativeIndexationEnabled,
} from '../app/selectors'
import { updateCsrfToken } from '../app/actions'
import {
    Vector,
    Rectangle,
    Position,
} from '../../helpers/math'
import {
    resetSearchQueryParam,
    updateSearchQueryParam,
} from '../queryParams/actions'
import { RepublicanDate } from '../../helpers/date/republicanDate'
import { GregorianDate } from '../../helpers/date/gregorianDate'

export function toggleCollaborativeIndexations()
{
    return function toggleCollaborativeIndexations(dispatch, getState)
    {
        if(areCollaborativeIndexationsDisplayed(getState()))
        {
            dispatch(hideCollaborativeIndexations())

            return
        }

        dispatch(displayCollaborativeIndexations())
    }
}

export const DISPLAY_COLLABORATIVE_INDEXATIONS = 'DISPLAY_COLLABORATIVE_INDEXATIONS'
export function displayCollaborativeIndexations()
{
    return function displayCollaborativeIndexations(dispatch, getState)
    {
        const media = getCurrentMedia(getState())

        dispatch({ type: DISPLAY_COLLABORATIVE_INDEXATIONS })
        dispatch(initCollaborativeIndexations(media))
    }
}

export const HIDE_COLLABORATIVE_INDEXATIONS = 'HIDE_COLLABORATIVE_INDEXATIONS'
export function hideCollaborativeIndexations()
{
    return function hideCollaborativeIndexations(dispatch, getState)
    {
        dispatch({ type: HIDE_COLLABORATIVE_INDEXATIONS })
        dispatch(unselectCollaborativeIndexationZone())
        dispatch(resetSearchQueryParam('collaborativeIndexation'))
    }
}

export function initCollaborativeIndexations(media)
{
    return function initCollaborativeIndexations(dispatch, getState)
    {
        const state = getState()
        if(
            ! areCollaborativeIndexationsDisplayed(state)
            || hasCollaborativeIndexations(state, media))
        {
            return
        }

        dispatch(fetchMediaCollaborativeIndexations(media))
    }
}

export const INIT_MEDIA_COLLABORATIVE_INDEXATIONS = 'INIT_MEDIA_COLLABORATIVE_INDEXATIONS'
export const initMediaCollaborativeIndexationList = (mediaUuid, collaborativeIndexations) => ({ type: INIT_MEDIA_COLLABORATIVE_INDEXATIONS, mediaUuid, collaborativeIndexations})

export function fetchMediaCollaborativeIndexations(media)
{
    return async function fetchMediaCollaborativeIndexations(dispatch, getState)
    {
        const state = getState()

        if(! isCollaborativeIndexationEnabled(state))
        {
            return
        }

        const serverUrl = getServerUrl(state)
        const url = `${serverUrl}/visualizer/api/collaborativeIndexations/media/${media.uuid}_${media.format}`
        await superagent
            .get(url)
            .then((res) => {
                dispatch(initMediaCollaborativeIndexationList(media.uuid, res.body))
            })
            .catch(function(err) {
                dispatch(addError('visualizer:error.label'))
            })
    }
}

export const SELECT_COLLABORATIVE_INDEXATION_ZONE = 'SELECT_COLLABORATIVE_INDEXATION_ZONE'
export function selectCollaborativeIndexationZone(indexationZone)
{
    return function selectCollaborativeIndexationZone(dispatch, getState)
    {
        dispatch(closeAllLeftAsides())
        dispatch({ type: SELECT_COLLABORATIVE_INDEXATION_ZONE, indexationZone })
        dispatch(updateSearchQueryParam('collaborativeIndexation', indexationZone.uuid))
        dispatch(openCollaborativeIndexationSummary())
    }
}

export const UNSELECT_COLLABORATIVE_INDEXATION_ZONE = 'UNSELECT_COLLABORATIVE_INDEXATION_ZONE'
export function unselectCollaborativeIndexationZone()
{
    return function unselectCollaborativeIndexationZone(dispatch, getState)
    {
        dispatch(({ type: UNSELECT_COLLABORATIVE_INDEXATION_ZONE }))
        dispatch(closeCollaborativeIndexationSummary())
        dispatch(resetSearchQueryParam('collaborativeIndexation'))
    }
}

export function closeAndUnselectCollaborativeIndexationSummary()
{
    return function closeAndUnselectCollaborativeIndexationSummary(dispatch)
    {
        dispatch(closeCollaborativeIndexationSummary())
        dispatch(unselectCollaborativeIndexationZone())
    }
}

export const OPEN_COLLABORATIVE_INDEXATION_SUMMARY = 'OPEN_COLLABORATIVE_INDEXATION_SUMMARY'
export const openCollaborativeIndexationSummary = () => ({ type: OPEN_COLLABORATIVE_INDEXATION_SUMMARY })

export const CLOSE_COLLABORATIVE_INDEXATION_SUMMARY = 'CLOSE_COLLABORATIVE_INDEXATION_SUMMARY'
export const closeCollaborativeIndexationSummary = () => ({ type: CLOSE_COLLABORATIVE_INDEXATION_SUMMARY })

export function toggleCollaborativeIndexationCreation()
{
    return function toggleCollaborativeIndexationCreation(dispatch, getState)
    {
        if(isCollaborativeIndexationCreationOpened(getState()))
        {
            dispatch(closeCollaborativeIndexationCreation())

            return
        }

        dispatch(openCollaborativeIndexationCreation())
    }
}

export const OPEN_COLLABORATIVE_INDEXATIONS_CREATION = 'OPEN_COLLABORATIVE_INDEXATIONS_CREATION'
export function openCollaborativeIndexationCreation()
{
    return function openCollaborativeIndexationCreation(dispatch)
    {
        dispatch(closeAllLeftAsides())
        dispatch({ type: OPEN_COLLABORATIVE_INDEXATIONS_CREATION })
        dispatch(lockLeftAside('collaborative-indexation-creation'))
        dispatch(displayCollaborativeIndexations())
        dispatch(unselectCollaborativeIndexationZone())
        dispatch(initCollaborativeIndexationCreationFields())
    }
}

export function confirmCloseCollaborativeIndexationCreation()
{
    return function confirmCloseCollaborativeIndexationCreation(dispatch)
    {
        dispatch(closeCollaborativeIndexationCreation(true))
    }
}

export const CLOSE_COLLABORATIVE_INDEXATIONS_CREATION = 'CLOSE_COLLABORATIVE_INDEXATIONS_CREATION'
export function closeCollaborativeIndexationCreation(closeConfirmed = false)
{
    return function closeCollaborativeIndexationCreation(dispatch, getState)
    {
        if(isCollaborativeIndexationCreationOpened(getState()) && closeConfirmed !== true)
        {
            dispatch({ type: CLOSE_COLLABORATIVE_INDEXATIONS_CREATION, confirmed: false})

            return
        }

        dispatch(unlockLeftAside())
        dispatch({ type: CLOSE_COLLABORATIVE_INDEXATIONS_CREATION, confirmed: true})
    }
}

export const CANCEL_COLLABORATIVE_INDEXATIONS_CREATION_CLOSE = 'CANCEL_COLLABORATIVE_INDEXATIONS_CREATION_CLOSE'
export const cancelCollaborativeIndexationCreationClose = () => ({ type: CANCEL_COLLABORATIVE_INDEXATIONS_CREATION_CLOSE })

export const UNSET_COLLABORATIVE_INDEXATION_CREATION_ZONE = 'UNSET_COLLABORATIVE_INDEXATION_CREATION_ZONE'
export const unsetCollaborativeIndexationCreationZone = () => ({ type: UNSET_COLLABORATIVE_INDEXATION_CREATION_ZONE })

export const INIT_COLLABORATIVE_INDEXATION_CREATION_FIELDS = 'INIT_COLLABORATIVE_INDEXATION_CREATION_FIELDS'
export function initCollaborativeIndexationCreationFields()
{
    return function initCollaborativeIndexationCreationFields(dispatch, getState)
    {
        const fields = getCollaborativeIndexationFormFields(getState())
        dispatch({ type: INIT_COLLABORATIVE_INDEXATION_CREATION_FIELDS, fields })
    }
}

export const SET_COLLABORATIVE_INDEXATION_CREATION_ZONE = 'SET_COLLABORATIVE_INDEXATION_CREATION_ZONE'
export const setCollaborativeIndexationCreationZone = (indexationZone, viewId) => (dispatch, getState) => {
    const state = getState()
    const scale = getScale(state, viewId)

    let width = indexationZone.width
    let height = indexationZone.height
    let position = indexationZone.position

    if(width < 0)
    {
        position = position.move(new Vector(width,0))
        width = Math.abs(width)
    }

    if(height < 0)
    {
        position = position.move(new Vector(0,height))
        height = Math.abs(height)
    }

    const minAuthorizedSize = getCollaborativeIndexationMinimumSelectionSize(state) * scale
    if(width < minAuthorizedSize || height < minAuthorizedSize)
    {
        dispatch(addErrorAlert('visualizer:toolbar.left.collaborativeIndexationCreation.form.selection.error'))

        return
    }

    indexationZone = new Rectangle(width, height, position).unscale(scale)

    dispatch({
        type: SET_COLLABORATIVE_INDEXATION_CREATION_ZONE,
        indexationZone: new Rectangle(
            Math.round(indexationZone.width),
            Math.round(indexationZone.height),
            new Position(Math.round(indexationZone.position.x), Math.round(indexationZone.position.y))
        ),
    })

    dispatch(moveToNextCollaborativeIndexationCreationStep())
    dispatch(disableCollaborativeIndexationCreationSelection())
}

export const MOVE_TO_NEXT_COLLABORATIVE_INDEXATION_CREATION_STEP = 'MOVE_TO_NEXT_COLLABORATIVE_INDEXATION_CREATION_STEP'
export function moveToNextCollaborativeIndexationCreationStep(validation)
{
    return function moveToNextCollaborativeIndexationCreationStep(dispatch)
    {
        if(typeof validation === 'function')
        {
            try
            {
                validation()
            }
            catch(e)
            {
                dispatch(setCollaborativeIndexationCreationInvalidFields(e.fields))

                return
            }
        }

        dispatch(resetCollaborativeIndexationCreationInvalidFields())
        dispatch({ type: MOVE_TO_NEXT_COLLABORATIVE_INDEXATION_CREATION_STEP })
    }
}

export const MOVE_TO_PREVIOUS_COLLABORATIVE_INDEXATION_CREATION_STEP = 'MOVE_TO_PREVIOUS_COLLABORATIVE_INDEXATION_CREATION_STEP'
export const moveToPreviousCollaborativeIndexationCreationStep = () => ({ type: MOVE_TO_PREVIOUS_COLLABORATIVE_INDEXATION_CREATION_STEP })

export const MOVE_TO_COLLABORATIVE_INDEXATION_STEP = 'MOVE_TO_COLLABORATIVE_INDEXATION_STEP'
export function moveToCollaborativeIndexationCreationStep(step, validations)
{
    return function moveToCollaborativeIndexationCreationStep(dispatch, getState)
    {
        let invalidFields = []
        Object.entries(validations).forEach(([step, validation]) => {
            if(typeof validation === 'function')
            {
                try
                {
                    validation()
                }
                catch(e)
                {
                    invalidFields = _.concat(invalidFields, e.fields)
                }
            }
        })

        if(! _.isEmpty(invalidFields))
        {
            dispatch(setCollaborativeIndexationCreationInvalidFields(invalidFields))

            return
        }

        dispatch(resetCollaborativeIndexationCreationInvalidFields())
        dispatch({ type: MOVE_TO_COLLABORATIVE_INDEXATION_STEP, step: Math.max(1, step - 1) })
    }
}

export const ENABLE_COLLABORATIVE_INDEXATION_CREATION_SELECTION = 'ENABLE_COLLABORATIVE_INDEXATION_CREATION_SELECTION'
export const enableCollaborativeIndexationCreationSelection = () => ({ type: ENABLE_COLLABORATIVE_INDEXATION_CREATION_SELECTION })

export const DISABLE_COLLABORATIVE_INDEXATION_CREATION_SELECTION = 'DISABLE_COLLABORATIVE_INDEXATION_CREATION_SELECTION'
export const disableCollaborativeIndexationCreationSelection = () => ({ type: DISABLE_COLLABORATIVE_INDEXATION_CREATION_SELECTION })

export function toggleCollaborativeIndexationCreationSelection()
{
    return function toggleCollaborativeIndexationCreationSelection(dispatch, getState)
    {
        if(isCollaborativeIndexationCreationSelectionToolActive(getState()))
        {
            dispatch(disableCollaborativeIndexationCreationSelection())

            return
        }

        dispatch(unsetCollaborativeIndexationCreationZone())
        dispatch(enableCollaborativeIndexationCreationSelection())
    }
}

export function createCollaborativeIndexation(fields)
{
    return async function createCollaborativeIndexation(dispatch, getState)
    {
        if(isCollaborativeIndexationCreationLocked(getState()))
        {
            return
        }

        dispatch(lockCollaborativeIndexationCreation())

        const media = getCurrentMedia(getState())
        const serverUrl = getServerUrl(getState())
        const zoneCreation = getCollaborativeIndexationSelection(getState())
        const url = `${serverUrl}/visualizer/api/collaborativeIndexations/media/${media.uuid}_${media.format}`
        await superagent.post(url)
            .type('form')
            .send({
                arkName: getCurrentMediaArkName(getState()),
                csrfToken: getCsrfToken(getState()),
                position: {
                    x: zoneCreation.position.x,
                    y: zoneCreation.position.y,
                    width: zoneCreation.width,
                    height: zoneCreation.height,
                },
                fields: {
                    ...fields,
                    indexationType: getCollaborativeIndexationCampaignIndexationType(getState())
                }
            })
            .then(res => {
                dispatch(fetchMediaCollaborativeIndexations(media))
                dispatch(confirmCloseCollaborativeIndexationCreation())
                dispatch(displayCollaborativeIndexations())
                dispatch(selectCollaborativeIndexationZone(res.body))
                dispatch(updateCsrfToken(res.body.csrfToken))
                dispatch(addSuccessAlert('visualizer:toolbar.left.collaborativeIndexationCreation.success.label'))
                dispatch(unlockCollaborativeIndexationCreation())
            })
            .catch(err => {
                if(err.response.body.message)
                {
                    dispatch(addErrorAlert(err.response.body.message))
                }
                else
                {
                    dispatch(addErrorAlert('visualizer:error.label'))
                }
                dispatch(updateCsrfToken(err.response.body.csrfToken))
                dispatch(unlockCollaborativeIndexationCreation())
            })
    }
}

export const INIT_COLLABORATIVE_INDEXATION_CAMPAIGN = 'INIT_COLLABORATIVE_INDEXATION_CAMPAIGN'
export const initCollaborativeIndexationCampaign = collaborativeIndexationCampaign => ({ type: INIT_COLLABORATIVE_INDEXATION_CAMPAIGN, collaborativeIndexationCampaign })

export const UPDATE_COLLABORATIVE_INDEXATION_FIELD_VALUE = 'UPDATE_COLLABORATIVE_INDEXATION_FIELD_VALUE'
export function updateCollaborativeIndexationFieldValue(field, value){
    return function updateCollaborativeIndexationFieldValue(dispatch, getState){
        let updatedValue = value
        if(
            value === undefined
            || (_.isString(value) && _.trim(value) === ''))
        {
            updatedValue = null
        }

        dispatch(({ type: UPDATE_COLLABORATIVE_INDEXATION_FIELD_VALUE, field : { name: field, value: updatedValue } }))
    }
}

export const ACTIVATE_COLLABORATIVE_INDEXER_STATUS = 'ACTIVATE_COLLABORATIVE_INDEXER_STATUS'
export function activateCollaborativeIndexerStatus()
{
    return async function activateCollaborativeIndexerStatus(dispatch, getState)
    {
        const serverUrl = getServerUrl(getState())
        const url = `${serverUrl}/user/api/v1/collaborativeIndexation/status/activate`

        await superagent.post(url)
            .then((res) => {
                if(res.accepted === true)
                {
                    return dispatch({ type: ACTIVATE_COLLABORATIVE_INDEXER_STATUS })
                }

                return dispatch(addError('visualizer:error.label'))
            })
            .catch(err => {
                dispatch(addError('visualizer:error.label'))
            })
    }
}

export function reportCollaborativeIndexation(message, captchaValidation)
{
    return async function reportCollaborativeIndexation(dispatch, getState)
    {
        const state = getState()
        const captcha = getCaptcha(state)
        const serverUrl = getServerUrl(state)
        const url = `${serverUrl}/visualizer/api/collaborativeIndexations/report/${getSelectedZone(state)}`
        const postData = {
            csrfToken: getCsrfToken(getState()),
            report: message,
        }

        if(captcha && captcha.isEnabled)
        {
            postData[captcha.postDataKey] = captchaValidation
        }

        await superagent.post(url)
            .type('form')
            .send(postData)
            .then((res) => {
                dispatch(addSuccessAlert("visualizer:toolbar.left.collaborativeIndexations.reporting.success"))
                dispatch(updateCsrfToken(res.body.csrfToken))
            })
            .catch(err => {
                dispatch(addErrorAlert("visualizer:toolbar.left.collaborativeIndexations.reporting.error"))
                dispatch(updateCsrfToken(err.response.body.csrfToken))
            })
    }
}

export const SET_COLLABORATIVE_INDEXATION_INVALID_FIELDS = 'SET_FIELDS_ERROR'
export const setCollaborativeIndexationCreationInvalidFields = (fields) => ({ type: SET_COLLABORATIVE_INDEXATION_INVALID_FIELDS, fields})

export const RESET_COLLABORATIVE_INDEXATION_CREATION_INVALID_FIELDS = 'RESET_COLLABORATIVE_INDEXATION_CREATION_INVALID_FIELDS'
export const resetCollaborativeIndexationCreationInvalidFields = () => ({ type: RESET_COLLABORATIVE_INDEXATION_CREATION_INVALID_FIELDS })

export const RESET_COLLABORATIVE_INDEXATION_CREATION_INVALID_FIELD = 'RESET_COLLABORATIVE_INDEXATION_CREATION_INVALID_FIELD'
export const resetCollaborativeIndexationCreationInvalidField = field => ({ type: RESET_COLLABORATIVE_INDEXATION_CREATION_INVALID_FIELD, field })

export function autoDisplayCollaborativeIndexations()
{
    return function autoDisplayCollaborativeIndexations(dispatch, getState)
    {
        if(isCollaborativeIndexationAutoDisplayEnabled(getState()))
        {
            dispatch(displayCollaborativeIndexations())
        }
    }
}

export const LOCK_COLLABORATIVE_INDEXATION_CREATION = 'LOCK_COLLABORATIVE_INDEXATION_CREATION'
export const lockCollaborativeIndexationCreation = () => ({ type: LOCK_COLLABORATIVE_INDEXATION_CREATION})

export const UNLOCK_COLLABORATIVE_INDEXATION_CREATION = 'UNLOCK_COLLABORATIVE_INDEXATION_CREATION'
export const unlockCollaborativeIndexationCreation = () => ({ type: UNLOCK_COLLABORATIVE_INDEXATION_CREATION})

export const updateCollaborativeIndexationGregorianDate = (dateField, dateParts) => dispatch => {
    dispatch(updateCollaborativeIndexationDate(
        dateField,
        dateParts,
        'gregorian',
        GregorianDate.MAX_DAYS,
        GregorianDate.MAX_MONTHS,
        GregorianDate.MAX_YEARS
    ))
}

export const updateCollaborativeIndexationRepublicanDate = (dateField, dateParts) => dispatch => {
    dispatch(updateCollaborativeIndexationDate(
        dateField,
        dateParts,
        'republican',
        RepublicanDate.MAX_DAYS,
        RepublicanDate.MONTHS.length,
        RepublicanDate.MAX_YEARS
    ))
}

export function updateCollaborativeIndexationDate(dateField, dateParts, calendarType, maxDays, maxMonths, maxYears)
{
    return function updateCollaborativeIndexationDate(dispatch)
    {
        const dateCalendar = buildDateCalendar(dateParts, calendarType, maxDays, maxMonths, maxYears)
        dispatch(updateCollaborativeIndexationFieldValue(dateField, dateCalendar))
    }
}

export const buildDateCalendar = (dateParts, calendarType) => {
    let {day = null, month = null, year = null} = dateParts
    let datePartsSet = false

    if (day !== null && day !== '')
    {
        day = Math.max(0, parseInt(day))
        datePartsSet = true
    }

    if (month !== null && month !== '')
    {
        month = Math.max(0, parseInt(month))
        datePartsSet = true
    }

    if (year !== null && year !== '')
    {
        year = Math.max(0, parseInt(year))
        datePartsSet = true
    }

    let date = null
    if (datePartsSet === true)
    {
        date = {
            type: calendarType,
            parts: {
                year,
                month,
                day
            }
        }
    }

    return date
}
